function initCardSliderArticle($slider) {
  const totalCards = $slider.find('.article-slider').length;
  const isMobile = window.innerWidth < 768;

  const $wrapper = $slider.closest('.articleWrapper');
  const $buttonContainer = $wrapper.find('.article-buttons-container');
  const $prevArrow = $wrapper.find('.slick-prev');
  const $nextArrow = $wrapper.find('.slick-next');

  $slider
    .removeClass('only-one-card stack-layout only-3-cards'); // Clean slate

  if (totalCards === 1) {
    $slider.addClass('only-one-card');
  }

  if (totalCards === 3 && !isMobile) {
    $slider.addClass('only-3-cards');
  }

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  if (isMobile) {
    if (totalCards <= 2) {
      $slider.addClass('stack-layout');
      $buttonContainer.hide();
    } else {
      $slider.slick({
        slidesToShow: 1.3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        draggable: true,
        swipe: true,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
      });
      $buttonContainer.show();
    }
  } else {
    $buttonContainer.hide();
  }
}

function toggleArticlePaddingClass() {
  $('.article-module-container').each(function () {
    if (window.innerWidth < 768) {
      $(this).addClass('no-padding');
    } else {
      $(this).removeClass('no-padding');
    }
  });
  $('.article-module-header').each(function () {
    if (window.innerWidth < 768) {
      $(this).addClass('mobile-padding');
    } else {
      $(this).removeClass('mobile-padding');
    }
  });
}

$(document).ready(function () {
  toggleArticlePaddingClass();
  $('.article-slick-slider').each(function () {
    initCardSliderArticle($(this));
  });
});

window.addEventListener('resize', () => {
  clearTimeout(window._imgResizeTimer);
  window._imgResizeTimer = setTimeout(() => {
    toggleArticlePaddingClass();
    $('.article-slick-slider').each(function () {
      initCardSliderArticle($(this));
    });
  }, 150);
});
